module.exports = "<style>#certsystem_refer td{cursor:pointer}</style> <div id=certsystem_refer> <div class=u-row style=min-height:464px> <u-grid params=\"config: config\"></u-grid> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./src/components/modalrefer/certSystem/index.html
// module id = 212
// module chunks = 144